import * as React from 'react';
import {FunctionComponent} from 'react';
import {EventType} from '../../../../models/PartEvent';

interface OwnProps {
    eventType: EventType;
}

export const Icon: FunctionComponent<OwnProps> = ({eventType}) => {
    switch (eventType) {
        case EventType.DataField0:
        case EventType.DataField1:
        case EventType.DataField2:
        case EventType.DataField3:
            return <span className="ion-ios-analytics" />;
        case EventType.Target:
            return <span className="ion-ios-aperture" />;
        case EventType.Instruction:
            return <span className="ion-ios-volume-high" />;
        case EventType.MainVisualisation:
            return <span className="ion-ios-stats" />;
    }
};
